import { css } from 'emotion';

import { mediaPhone } from './breakpoints';

export const LOGO_PHONE_SCALE = 0.73333;

export const px = px_ => `${Math.round(px_)}px`;

export const LogoLabelColor = '#A7A7A7';
export const LogoLabelFontSize = '13px';

export const LogoLabelStyles = css`
  font-size: ${LogoLabelFontSize};
  font-weight: normal;

  color: ${LogoLabelColor};

  padding-bottom: 4px;
`;

export const HideLogoLabelOnPhoneStyles = css`
  ${mediaPhone} {
    display: none;
  }
`;



// WEBPACK FOOTER //
// ./src/components/styles/Logo.js